import actionTypes from 'SRC/modules/redux/actionTypes'

export const setSimilarAdsLoading = (isLoading) => {
  return {
    type: actionTypes.SET_SIMILAR_ADS_LOADING,
    payload: isLoading
  }
}
